import React from "react";
import Page from "../Components/Page";
import { useParams } from "react-router-dom";
import { ITimer } from "../features/controls/timer/types";
import TimerPanel from "../features/controls/timer/TimerForm";
import {
  getCommandOptions,
  getCommandParameterOptions,
} from "../features/automations/utils";
import useFetchData from "../hooks/useFetchData";
import { IControl, IControlCommandBase } from "../features/controls/types";
import { timerToString } from "../features/controls/timer/utils";
import { defaultTimeTrigger } from "../features/automations/triggers/types";
import { useTranslation } from "react-i18next";

const newEmptyTimer = (control: IControl): ITimer => {
  const initialCommand = getCommandOptions(control as IControlCommandBase)[0]
    .value as string;
  const initialParameter = getCommandParameterOptions(
    control as IControlCommandBase,
    initialCommand
  )[0].value as string;
  return {
    id: -1,
    name: "timer",
    is_enabled: true,
    trigger: defaultTimeTrigger,
    condition: {
      type: "none",
    },
    action: {
      type: "mqtt",
      control_id: control.id,
      command: initialCommand,
      parameter: initialParameter,
    },
  };
};

export const NewTimerPage = () => {
  const params = useParams();
  const { data: control, isLoading } = useFetchData<IControl>(
    `/controls/${params.controlid}`
  );
  const { t } = useTranslation();
  return (
    <Page title={t("New Timer")} isLoading={isLoading}>
      {control && (
        <TimerPanel timer={newEmptyTimer(control)} control={control} />
      )}
    </Page>
  );
};

export const EditTimerPage = () => {
  const params = useParams();
  const { data: control, isLoading: isControlLoading } = useFetchData<IControl>(
    `/controls/${params.controlid}`
  );
  const { data: timer, isLoading: isTimerLoading } = useFetchData<ITimer>(
    `/timers/${params.timerid}`
  );
  return (
    <Page
      title={(timer && timerToString(timer)) || "New Timer"}
      isLoading={isControlLoading || isTimerLoading}
    >
      {timer && control && <TimerPanel timer={timer} control={control} />}
    </Page>
  );
};
